import{useIsomorphicLayoutEffect as e}from"./use-isomorphic-layout-effect.js";const o=(o,t)=>{e((()=>(window.addEventListener(o,t,{passive:!0}),()=>{window.removeEventListener(o,t)})),[t])};export{o as useWindowEventHandler};
